export function isArrayNullOrEmpty(arrayObject) {
    return !Array.isArray(arrayObject) || arrayObject.length == 0;
}
/***
 * This will to find out if key exists by value in mapper object
 */
export const hasKeyExistsByValueInMapper = (mapperObject, keyValue, isValueExists = false) => {
    mapperObject.forEach(ConfigKey => {
        if (ConfigKey === keyValue) {
            isValueExists = true;
        }
    });
    return isValueExists;
};
//This will check if value exists in array
export function isArrayhasValue(arrayObject, value) {
    return arrayObject.includes(value);
}
//# sourceMappingURL=ArrayUtils.js.map